export interface CaregiverRowData {
  selected: boolean;
  isFromSis: boolean; // true = SIS row (name read-only), false = manual row
  firstName: string;
  lastName: string;
  relationship: string;
  phoneNumber: string;
  email: string;
}

export interface ImportCaregiverFormData {
  caregivers: CaregiverRowData[];
}

export const RELATIONSHIP_OPTIONS = [
  { label: 'Parent or Guardian', value: 'guardian' },
  { label: 'Relative', value: 'relative' },
  { label: 'Social Worker', value: 'social_worker' },
  { label: 'Educational Specialist', value: 'ed_specialist' },
  { label: 'Other', value: 'other' },
];

export const MAX_CAREGIVERS = 5;
